var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReservation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6V7.5H6V6H10.5ZM6 10.5V9H10.5V10.5H6ZM6 13.5V12H9V13.5H6ZM4.5 6V7.5H3V6H4.5ZM4.5 9V10.5H3V9H4.5ZM3 13.5V12H4.5V13.5H3ZM1.5 1.5V22.5H9V24H0V0H13.0664L19.5 6.43359V9H18V7.5H12V1.5H1.5ZM13.5 2.56641V6H16.9336L13.5 2.56641ZM21 12H24V24H10.5V12H13.5V10.5H15V12H19.5V10.5H21V12ZM22.5 22.5V16.5H12V22.5H22.5ZM22.5 15V13.5H12V15H22.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/Reservation.9ec7e828acad7b16e63660fea2a92ce0.svg";
export { ForwardRef as ReactComponent };